import stripeWidgetStore from '@modules/stripe/stripe-balance/stripe-balance-widget-store';

export default {
  namespaced: true,

  modules: {
    list: stripeWidgetStore,
  },
};
